import React, { useEffect, useState } from 'react';
import methodModel from '../../../methods/methods';
import { Link, useNavigate } from 'react-router-dom';
import './style.scss';
import PhoneInput from 'react-phone-input-2';
import SelectDropdown from '../../common/SelectDropdown';
import MultiSelectDropdown from '../../common/MultiSelectDropdown';
import countryStateModel from '../../../models/countryState.model';
import timezoneModel from '../../../models/timezone.model';
import ImageUpload from '../../common/ImageUpload';
import ApiClient from '../../../methods/api/apiClient';
import environment from '../../../environment';
import { MdDeleteOutline } from "react-icons/md";
import FormControl from '../../common/FormControl';

// Preset industries/verticals (shared with the onboarding wizard). Users can add their own via "Other".
export const INDUSTRY_OPTIONS = [
  'Digital Health', 'Distribution', 'e-commerce', 'Engineering', 'Entertainment',
  'Finance', 'Fintech', 'Hardware', 'Healthcare', 'Legal', 'Logistics',
  'Manufacturing', 'Medtech', 'Networking', 'Professional Services', 'Restaurant',
  'SaaS', 'Security', 'Semiconductor', 'Software', 'Solartech', 'Supply Chain',
  'Travel', 'Wholesale',
];

export const REVENUE_RANGES = [
  '< $500K', '$500K–$1M', '$1M–$5M', '$5M–$25M', '$25M–$100M', '$100M+',
];


const Html = ({ handleSubmit, setForm, form, getError,imageResult,images, uploadImage, submitted, groupEditId = '', groupList = [], pickGroup = (_gid) => {}, isOtherUser = false }) => {
  const history = useNavigate();



  const editAddress = (i, v, key = 'value') => {
    let arr = form.multiAddress || []
    arr[i][key] = v
    setForm({ ...form, multiAddress: [...arr] })
  }

  const addAddress = () => {
    let arr = form.multiAddress || []
    let aid=String(new Date().getTime())
    arr.push({ id:aid})
    setForm({ ...form, multiAddress: [...arr] })
  }

  const removeAddress = (i) => {
    let arr = form.multiAddress || []
    arr = arr.filter((itm, index) => index != i)
    setForm({ ...form, multiAddress: [...arr] })
  }

  const [certificate, setCertificate] = useState([])
  const [skillRoles, setSkillRoles] = useState([])
  const [categories, setCategories] = useState([])
  const [states, setState] = useState([])
  const [subcategories, setSubCategories] = useState([])
  const [subsubcategories, setSubSubCategories] = useState([])
  const [eyes, setEyes] = useState({})
  const countries=countryStateModel.list
  const timezones=timezoneModel.list
  const [roles, setRoles] = useState([])


const getCertificates = () => {
  ApiClient.get('api/certificate/list', { status: 'active' }).then(res => {
    if (res.success) {
      setCertificate(res.data)
    }
  })
}

const getSkills = () => {
  ApiClient.get('api/skills/listing', { status: 'active',
  // skillRole:form.customerRole
 }).then(res => {
    if (res.success) {
      setSkillRoles(res.data)
    }
  })
}
const getCategories = () => {
  ApiClient.get('api/categorie/list', { status: 'active',catType:environment.professionType }).then(res => {
    if (res.success) {
      setCategories(res.data)
    }
  })
}

const getSubCategories = (p={}) => {
  ApiClient.get('api/categorie/list', { status: 'active',catType:environment.professionType,...p }).then(res => {
    if (res.success) {
      setSubCategories(res.data)
    }
  })
}


const getSubSubCategories = (p={}) => {
  ApiClient.get('api/categorie/list', { status: 'active',catType:environment.professionType,...p }).then(res => {
    if (res.success) {
      setSubSubCategories(res.data)
    }
  })
}

const capitalizeSecondWord = (text) => {
  const parts = text.split(' ', 2);
  if (parts.length === 2) {
    const [firstWord, secondWord] = parts;
    return `${firstWord} ${secondWord.charAt(0).toUpperCase() + secondWord.slice(1)}`;
  }
  return text;
};

useEffect(() => {
  getCertificates()
  getCategories()
  getSkills()
}, [])

useEffect(() => {
  // if(form.customerRole){
  //   getSkills()
  // }
}, [form.customerRole])

useEffect(() => {
  if(form.category){
    getSubCategories({parentCategory:form.category})
  }
}, [form.category])

useEffect(() => {
  if(form.subCategory){
    getSubSubCategories({parentCategory:form.subCategory})
  }
}, [form.subCategory])

useEffect(() => {
  if(form.country){
    let arr=countryStateModel.getStates(form.country)
    setState([...arr])
  }
}, [form.country])


const getRoles=()=>{
  ApiClient.get('api/skillRole/list',{status:'active'}).then(res=>{
      if(res.success){
          setRoles(res.data)
      }
  })
}

useEffect(()=>{
  getRoles()
},[])


  return (
    <>

      <div className='wrapper_section'>
        <form name="profileForm" className="" onSubmit={handleSubmit} onKeyDown={(e) => { if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') e.preventDefault(); }} >
        <div className='flex items-center justify-between'>
          <div className='flex items-center'>
            <button type="button" onClick={() => history(isOtherUser ? '/members' : '/profile')} className="!px-4 py-2 flex items-center justify-center rounded-lg shadow-btn hover:bg-[#F3F2F5] border transition-all mr-3"><i className='fa fa-angle-left text-lg'></i></button>
            <h3 className='text-2xl font-semibold text-[#111827]'>Edit Profile</h3>
          </div>
          <button type="submit" className="text-white bg-orange-400 bg-orange-600 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Save</button>
        </div>


        <div className="grid grid-cols-12 mb-4 gap-4 shadow p-4 mt-6 gap-4">
            <div className="col-span-12 md:col-span-6">
              <FormControl
              type="text"
              label="First Name"
              value={form.firstName}
              className="capitalize"
              onChange={e => setForm({ ...form, firstName: e })}
              required
              />
            </div>

            <div className="col-span-12 md:col-span-6">
              <FormControl
              type="text"
              label="Last Name"
              value={form.lastName}
              className="capitalize"
              onChange={e => setForm({ ...form, lastName: e })}
              required
              />
            </div>

            <div className="col-span-12 md:col-span-6">
              <FormControl
              type="text"
              label="Profession Title"
              value={form.profession}
              onChange={e => setForm({ ...form, profession: e })}
              //required
              />
            </div>



            <div className="col-span-12 md:col-span-6">
              <label>Mobile No{/*<span className="star">*</span>*/}</label>
              <PhoneInput
                country={'us'}
                value={form.mobileNo}
                enableSearch={true}
                limitMaxLength
                //required
                onChange={e => setForm({ ...form, mobileNo: e })}
                countryCodeEditable={true}
                minlegth="10"
              />
              {submitted && getError('mobileNo').invalid ? <div className="invalid-feedback d-block">Min Length is 10</div> : <></>}
            </div>
            {/* login Id field removed - using email for authentication */}
            <div className="col-span-12 md:col-span-6">
              <label>Email {<span className="star">*</span>} </label>
              <input
                type="text"
                className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2 text-sm break-all"
                value={form.email}
                autoComplete="false"
                onChange={e => { setForm({ ...form, email: e.target.value }); }}
                required
                pattern="[^@\s]+@[^@\s]+"
                title="Please enter a valid email address"
              />
            </div>
            
            <div className="col-span-12 md:col-span-6">
              <label>Secondary Email  </label>
              <input
                type=" Secondary email"
                className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2"
                value={form.secondaryEmail}
                autoComplete="false"
                onChange={e => { setForm({ ...form, secondaryEmail: e.target.value }); }}
                //required
                // disabled
              />

            </div>

            <div className="col-span-12 md:col-span-6">
              <label className='lablefontcls'>Image</label><br></br>
              <ImageUpload model="users" result={e => imageResult(e, 'image')} value={images.image || form.image} multiple={false} />
            </div>


            <div className="col-span-12 md:col-span-6">
              <label>Company{/*<span className="star">*</span>*/}</label>
              <input
                type="text"
                className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2"
                value={form.company}
                onChange={e => setForm({ ...form, company: e.target.value })}
                //required
              />
            </div>

            <div className="col-span-12 md:col-span-6">
              <label>Company URL{/*<span className="star">*</span>*/}</label>
              <input
                type="text"
                className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2"
                value={form.companyUrl}
                onChange={e => setForm({ ...form, companyUrl: e.target.value })}
                //required
              />
            </div>

            <div className="col-span-12 md:col-span-6">
              <label>Address{/*<span className="star">*</span>*/}</label>
              <input
                type="text"
                className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2"
                value={form.address}
                onChange={e => setForm({ ...form, address: e.target.value })}
                //required
              />
            </div>

            <div className="col-span-12 md:col-span-6">
              <label>Address 2{/*<span className="star">*</span>*/}</label>
              <input
                type="text"
                className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2"
                value={form.address2}
                onChange={e => setForm({ ...form, address2: e.target.value })}
                
              />
            </div>

            <div className="col-span-12 md:col-span-6">
              <label>Country{/*<span className="star">*</span>*/}</label>
              <SelectDropdown
                id="statusDropdown"
                displayValue="name"
                placeholder="Select Country"
                intialValue={form.country}
                result={e => { setForm({ ...form, country: e.value,state:'' }) }}
                options={countries}
                theme="search"
              />
            </div>

            <div className="col-span-12 md:col-span-6">
              <label>State/Province{/*<span className="star">*</span>*/}</label>
              <SelectDropdown
                id="statusDropdown"
                displayValue="name"
                placeholder="Select State/Province"
                intialValue={form.state}
                result={e => { setForm({ ...form, state: e.value }) }}
                options={states}
                theme="search"
              />
            </div>
            <div className="col-span-12 md:col-span-6">
              <label>Zip/Postal Code{/*<span className="star">*</span>*/}</label>
              <input
                type="number"
                className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2"
                value={form.postal_code}
                onChange={e => setForm({ ...form, postal_code: e.target.value })}
                //required
              />
            </div>
            <div className="col-span-12 md:col-span-6">
              <label>City{/*<span className="star">*</span>*/}</label>
              <input
                type="text"
                className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2"
                value={form.city}
                onChange={e => setForm({ ...form, city: e.target.value })}
                //required
              />
            </div>
            <div className="col-span-12 md:col-span-6">
              <label>Timezone{/*<span className="star">*</span>*/}</label>
              <SelectDropdown
                id="statusDropdown"
                displayValue="name"
                placeholder="Select Timezone"
                intialValue={form.timezone}
                result={e => { setForm({ ...form, timezone: e.value }) }}
                options={timezones}
                theme="search"
              />
            </div>

            {/* <div className="col-span-12 md:col-span-6">
              <label>Customer Role<span className="star">*</span></label>
              <SelectDropdown
                id="statusDropdown"
                displayValue="name"
                placeholder="Select Customer Role"
                intialValue={form.customerRole}
                result={e => { setForm({ ...form, customerRole: e.value,skills:[] }) }}
                options={roles}
                theme="search"
                disabled
              />
              {submitted && !form.customerRole ? <div className="invalid-feedback d-block">Customer Role is Required</div> : <></>}
            </div> */}

            {/* <div className="col-span-full">
              <label>Admin Comment</label>
              <textarea disabled
                className="relative shadow-box bg-white w-full rounded-lg flex items-center gap-2 overflow-hidden px-2"
                value={form.adminComment}
                onChange={e => setForm({ ...form, adminComment: e.target.value })}

              ></textarea>
            </div> */}



            <div className="col-span-12 md:col-span-6">
              <label>Linkedin Profile URL</label>
              <input
                type="text"
                className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2"
                value={form.linkedInUrl}
                onChange={e => setForm({ ...form, linkedInUrl: e.target.value })}
              />
            </div>
            {/* cw: Certification field hidden for now (commented out, not deleted)
            <div className="col-span-12 md:col-span-6">
              <label>Certification</label>
              <SelectDropdown
                id="statusDropdown"
                displayValue="name"
                placeholder="Select Certification"
                intialValue={form.certification}
                result={e => { setForm({ ...form, certification: e.value }) }}
                options={certificate}
                theme="search"
              />
              {submitted && !form.certification ? <div className="invalid-feedback d-block">Certification is Required</div> : <></>}
            </div>
            */}

           
           
          </div>



          <div className="hidden">
             {/* cw: hidden Skills, Networking Groups, Profession Categories for now */}
             {false && <><div className="col-span-12 md:col-span-6">
                 <label>Skills</label>
                 <MultiSelectDropdown
                   displayValue="title"
                   placeholder="Select Skills"
                   intialValue={form.skills}
                   result={e => {
                     setForm({ ...form, skills: e.value })
                    
                   }}
                   options={skillRoles}
                   theme="search"
                 />
                 {/* {submitted && !form.skills?.length ? <div className="invalid-feedback d-block">Skills is Required</div> : <></>} */}
               </div>
 
             <div className="col-span-full">
               <label>Networking Groups</label>
               <textarea
                 className="relative shadow-box bg-white w-full rounded-lg flex items-center gap-2 overflow-hidden px-2"
                 value={form.networkingGroup}
                 onChange={e => setForm({ ...form, networkingGroup: e.target.value })}
 
               ></textarea>
             </div>
 
             <div className="col-span-12 md:col-span-6">
               <label>Profession Category</label>
               <SelectDropdown
                 id="statusDropdown"
                 displayValue="name"
                 placeholder="Select Profession Category"
                 intialValue={form.category}
                 result={e => { setForm({ ...form, category: e.value,subCategory:'' }) }}
                 options={categories}
                 theme="search"
               />
               {/* {submitted && !form.category ? <div className="invalid-feedback d-block">Profession Category is Required</div> : <></>} */}
             </div>
 
             <div className="col-span-12 md:col-span-6">
               <label>Profession Sub Category</label>
               <SelectDropdown
                 id="statusDropdown"
                 displayValue="name"
                 placeholder="Select Profession Sub Category"
                 intialValue={form.subCategory}
                 result={e => { setForm({ ...form, subCategory: e.value }) }}
                 options={subcategories}
                 theme="search"
               />
               {/* {submitted && !form.subCategory ? <div className="invalid-feedback d-block">Profession Sub Category is Required</div> : <></>} */}
             </div>

            <div className="col-span-12 md:col-span-6">
              <label>Profession Sub Sub Category</label>
              <SelectDropdown
                id="statusDropdown"
                displayValue="name"
                placeholder="Select Profession Sub Sub Category"
                intialValue={form.subSubCategory}
                result={e => { setForm({ ...form, subSubCategory: e.value }) }}
                options={subsubcategories}
                theme="search"
              />
              {/* {submitted && !form.subCategory ? <div className="invalid-feedback d-block">Profession Sub Category is Required</div> : <></>} */}
            </div></>}


             </div>

            <div className='shadow grid grid-cols-12 gap-4 mb-4 p-4'>
              <div className="col-span-full">
                <h4 className="text-1xl font-semibold text-[#111827] mb-2">Profile Details</h4>
                <p className="text-sm text-gray-400 mb-3">
                  By default, every group shows this profile. Select a group to show a different profile just for that group. Only these fields will change per group.
                </p>
                {/* cw: per-group profile selector (Option A, unified box) — governs the fields in THIS box. */}
                <label className="block text-1xl font-semibold text-[#111827] mb-1">Editing profile for:</label>
                <select
                  value={groupEditId}
                  onChange={e => pickGroup(e.target.value)}
                  className="w-full md:w-80 border border-gray-300 rounded px-3 py-2 text-sm"
                >
                  <option value="">Default (all groups)</option>
                  {(groupList || []).map(g => <option key={g.id} value={g.id}>{g.name}</option>)}
                </select>
                {groupEditId && (
                  <div className="mt-3">
                    <div className="inline-flex flex-col bg-[#EF7A2B] text-white px-6 py-2 rounded-lg">
                      <span className="font-semibold capitalize">{((groupList || []).find(g => g.id === groupEditId) || {}).name || 'Group'}</span>
                      <span className="text-xs opacity-90">Editing this group's profile</span>
                    </div>
                  </div>
                )}
              </div>
              <div className="col-span-12 md:col-span-6">
                <label>Professional Headline</label>
                <input type="text" className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" value={form.pd_headline || ''} onChange={e => setForm({ ...form, pd_headline: e.target.value })} placeholder="e.g. CPA | Tax Strategy for Small Businesses" />
              </div>
              <div className="col-span-12 md:col-span-6">
                <label>Industry</label>
                <input type="text" className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" value={form.pd_industry || ''} onChange={e => setForm({ ...form, pd_industry: e.target.value })} placeholder="e.g. Technology, Real Estate" />
              </div>
              <div className="col-span-full">
                <label>Short Bio</label>
                <textarea
                  className="relative shadow-box bg-white w-full rounded-lg flex items-center gap-2 overflow-hidden px-2"
                  value={form.aboutUs}
                  onChange={e => setForm({ ...form, aboutUs: e.target.value })}
                ></textarea>
              </div>
              <div className="col-span-full">
                <label>Specialties <span className="text-xs text-gray-400">(comma-separated)</span></label>
                <input type="text" className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" value={form.pd_specialties || ''} onChange={e => setForm({ ...form, pd_specialties: e.target.value })} placeholder="e.g. tax planning, bookkeeping, payroll" />
              </div>
              <div className="col-span-12 md:col-span-6">
                <label>Services Offered <span className="text-xs text-gray-400">(comma-separated)</span></label>
                <input type="text" className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" value={form.pd_servicesOffered || ''} onChange={e => setForm({ ...form, pd_servicesOffered: e.target.value })} placeholder="e.g. web dev, consulting" />
              </div>
              <div className="col-span-12 md:col-span-6">
                <label>Services Needed <span className="text-xs text-gray-400">(comma-separated)</span></label>
                <input type="text" className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" value={form.pd_servicesNeeded || ''} onChange={e => setForm({ ...form, pd_servicesNeeded: e.target.value })} placeholder="e.g. bookkeeping, marketing" />
              </div>
              <div className="col-span-full">
                <label>"Call Me When..."</label>
                <input type="text" className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" value={form.pd_callMeWhen || ''} onChange={e => setForm({ ...form, pd_callMeWhen: e.target.value })} placeholder="e.g. You know someone who needs a new website" />
              </div>
              <div className="col-span-12 md:col-span-6">
                <label>Customer Pain Point</label>
                <input type="text" className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" value={form.pd_painPoint || ''} onChange={e => setForm({ ...form, pd_painPoint: e.target.value })} placeholder="e.g. struggling with outdated technology" />
              </div>
              <div className="col-span-12 md:col-span-6">
                <label>Target Geography</label>
                <input type="text" className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" value={form.pd_geography || ''} onChange={e => setForm({ ...form, pd_geography: e.target.value })} placeholder="e.g. San Diego, Southern California" />
              </div>
              <div className="col-span-12 md:col-span-4">
                <label>Customer Type</label>
                <select className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" value={form.pd_businessType || ''} onChange={e => setForm({ ...form, pd_businessType: e.target.value })}>
                  <option value="">Select...</option>
                  <option value="B2B">B2B</option>
                  <option value="B2C">B2C</option>
                  <option value="Nonprofit">Nonprofit</option>
                  <option value="Other">Other</option>
                </select>
                {form.pd_businessType === 'Other' && (
                  <input type="text" className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2 mt-2" value={form.pd_businessTypeOther || ''} onChange={e => setForm({ ...form, pd_businessTypeOther: e.target.value })} placeholder="Describe your customer type" />
                )}
              </div>
              <div className="col-span-12 md:col-span-4">
                <label>Revenue <span className="text-xs text-gray-400">(enter a range minimum–maximum)</span></label>
                <div className="flex items-center gap-2">
                  <input type="text" className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" value={form.pd_revenueMin || ''} onChange={e => setForm({ ...form, pd_revenueMin: e.target.value })} placeholder="Min" />
                  <span className="text-gray-400">–</span>
                  <input type="text" className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" value={form.pd_revenueMax || ''} onChange={e => setForm({ ...form, pd_revenueMax: e.target.value })} placeholder="Max" />
                </div>
              </div>
              <div className="col-span-12 md:col-span-4">
                <label>Number of Employees</label>
                <input type="number" className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" value={form.pd_employeeCount || ''} onChange={e => setForm({ ...form, pd_employeeCount: e.target.value })} placeholder="e.g. 50" />
              </div>
              <div className="col-span-12 md:col-span-4">
                <label>Number of Seats</label>
                <input type="number" className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" value={form.pd_seats || ''} onChange={e => setForm({ ...form, pd_seats: e.target.value })} placeholder="e.g. 25" />
              </div>
              <div className="col-span-12 md:col-span-4">
                <label>Website URL</label>
                <input type="text" className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" value={form.pd_websiteUrl || ''} onChange={e => setForm({ ...form, pd_websiteUrl: e.target.value })} placeholder="https://yoursite.com" />
              </div>
              <div className="col-span-12 md:col-span-4">
                <label>Years of Experience</label>
                <input type="number" className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" value={form.pd_yearsExperience || ''} onChange={e => setForm({ ...form, pd_yearsExperience: e.target.value })} />
              </div>
              <div className="col-span-12">
                <label>Which industries do you serve</label>
                <div className="flex flex-wrap gap-2 mt-1">
                  {INDUSTRY_OPTIONS.map(name => {
                    const active = (form.pd_industriesServed || []).includes(name);
                    return (
                      <button
                        type="button"
                        key={name}
                        onClick={() => setForm({
                          ...form,
                          pd_industriesServed: active
                            ? (form.pd_industriesServed || []).filter(x => x !== name)
                            : [...(form.pd_industriesServed || []), name],
                        })}
                        className={`text-xs px-3 py-1.5 rounded-full border transition-colors ${active ? 'bg-orange-500 border-orange-500 text-white' : 'bg-white border-gray-300 text-gray-700 hover:bg-gray-50'}`}
                      >
                        {name}
                      </button>
                    );
                  })}
                </div>
                <input type="text" className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2 mt-2" value={form.pd_industryOther || ''} onChange={e => setForm({ ...form, pd_industryOther: e.target.value })} placeholder="Other (not listed) — comma-separated" />
              </div>
              <div className="col-span-12 md:col-span-4">
                <label>Referral Fee</label>
                <input type="text" className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" value={form.pd_referralFee || ''} onChange={e => setForm({ ...form, pd_referralFee: e.target.value })} placeholder="e.g. 10% for first 6 months" />
              </div>
              <div className="col-span-12 md:col-span-4">
                <label>Current Promotions</label>
                <input type="text" className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" value={form.pd_promotions || ''} onChange={e => setForm({ ...form, pd_promotions: e.target.value })} placeholder="e.g. Free consult through Dec" />
              </div>
              <div className="col-span-12 md:col-span-4">
                <label>Preferred Contact</label>
                <select className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" value={form.pd_preferredContact || ''} onChange={e => setForm({ ...form, pd_preferredContact: e.target.value })}>
                  <option value="">Select...</option>
                  <option value="email">Email</option>
                  <option value="phone">Phone</option>
                  <option value="linkedin">LinkedIn</option>
                </select>
              </div>
            </div>

            {/* cw: hidden address section for now */}
            {false && <div className='shadow grid grid-cols-12 gap-4 mb-4  p-4'>
            <div className="col-span-full ">
            <div className=" ">
              {/* <h4 className="text-1xl font-semibold text-[#111827]">Addresses</h4> */}
              <div className=''>

             
              <div className="">
                {form?.multiAddress?.map((itm, i) => {
                  return <>
                    <div className="grid grid-cols-2 gap-2 shadow bg-white p-4 p-3 mb-3 bg-white rounded-md">
                      <div className="">
                        <label>First Name</label>
                        <input type="text"
                          className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2"
                          value={itm.firstName}
                          onChange={(e) => editAddress(i, e.target.value, 'firstName')}
                          //required
                        />
                      </div>
                      <div className="">
                      <label>Last Name</label>
                        <input type="text"
                          className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2"
                          value={itm.lastName}
                          onChange={(e) => editAddress(i, e.target.value, 'lastName')}
                        />
                      </div>
                      <div className="">
                        <label>Email</label>
                        <input type="text"
                          className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2"
                          value={itm.email}
                          onChange={(e) => editAddress(i, e.target.value, 'email')}
                          required
                        />
                      </div>
                      <div className="">
                        <label>Phone Number</label>
                        <PhoneInput
                          country={'us'}
                          value={itm.mobileNo}
                          enableSearch={true}
                          limitMaxLength
                          //required
                          onChange={e =>editAddress(i, e, 'mobileNo')}
                          countryCodeEditable={true}
                        />
                      </div>
                      <div className="">
                      <label>Address</label>
                        <input type="text"
                          className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2"
                          value={itm.address}
                          onChange={(e) => editAddress(i, e.target.value, 'address')}
                          //required
                        />
                      </div>
                      <div className='relative'>
                          <div className='bg-red-500 absolute right-0 top-6  rounded-md p-2 cursor-pointer' onClick={() => removeAddress(i)}>
                           
                            <p className='flex items-center gap-x-2 text-white'>  <MdDeleteOutline className=" text-white"  /> Delete</p>
                          </div>
                      </div>
                    </div>
                  </>
                })}


              </div>
              <div className="text-right mt-3">
                {/* <button type="button" onClick={addAddress} className="text-white bg-orange-400 bg-orange-600 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Add Address</button> */}
              </div>
              </div>
              </div>
            </div>
            </div>}

        </form>





      </div>


    </>
  );
};

export default Html;
